import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import { withAliases } from '../../../ui/utils/with-aliases';
var Option = function (_a) {
    var children = _a.children;
    return _jsx("div", { children: children });
};
var BaseSwitch = function (_a) {
    var _b;
    var selectedOption = _a.selectedOption, onSelect = _a.onSelect, children = _a.children, fullWidth = _a.fullWidth, className = _a.className, disabled = _a.disabled;
    var options = React.Children.toArray(children)
        .filter(function (child) { return React.isValidElement(child) && child.type === Option; })
        .map(function (child) { return child; });
    return (_jsx("div", { className: classNames(styles['switch-container'], (_b = {}, _b[styles['full-width']] = fullWidth, _b), className), children: options.map(function (_a) {
            var _b;
            var _c = _a.props, optionChildren = _c.children, value = _c.value;
            return (_jsx("button", { className: classNames(styles['switch-option'], (_b = {},
                    _b[styles.selected] = value === selectedOption,
                    _b[styles['full-width']] = fullWidth,
                    _b[styles.disabled] = disabled,
                    _b)), onClick: function () { return onSelect(value); }, "data-automation-id": "switchOption:".concat(value, ":").concat(value === selectedOption), type: "button", children: optionChildren }, value));
        }) }));
};
export var Switch = withAliases(BaseSwitch, {
    Option: Option,
});
